export type DocumentMimeKind = 'pdf' | 'image' | 'unsupported';

export type FindMode = 'contains' | 'whole';

export type FindHintLocateKind = 'value' | 'ssnPattern' | 'money';

export interface FindHint {
    id: string;
    label: string;
    value: string;
    detail?: string;
    priority?: 'required' | 'supporting';
    variants?: string[];
    pageHint?: number;
    matchMode?: FindMode;
    locateKind?: FindHintLocateKind;
    /** When set, this supporting helper is shown under the related required field when that field is missing. */
    relatedTo?: string;
}

export interface DocumentRef {
    docType: number;
    lookupId: number;
    fileId?: number;
    label?: string;
    fileIndex?: number;
    totalFiles?: number;
}

export interface DocumentContent {
    url: string;
    mimeKind: DocumentMimeKind;
    mimeType?: string;
    hasText?: boolean;
}

export type OcrJobStatus = 'idle' | 'not_configured' | 'unsupported' | 'queued' | 'running' | 'succeeded' | 'failed';

export interface OcrWordBox {
    text: string;
    x0: number;
    y0: number;
    x1: number;
    y1: number;
}

export interface OcrJobResult {
    status: OcrJobStatus;
    message?: string;
    text?: string;
    words?: OcrWordBox[];
    imageWidth?: number;
    imageHeight?: number;
}

export interface TextSearchHit {
    pageIndex: number;
    matchIndex: number;
    start?: number;
    end?: number;
    itemIndices?: number[];
    snippet?: string;
    snippetMatchStart?: number;
    snippetMatchEnd?: number;
}
